import { FormattedMessage } from "react-intl";
import { Link as RouterLink } from "react-router-dom";

import { useFetchData } from "@dzambalaorg/react-hooks";
import type { IContract } from "@framework/types";
import { Button } from "@dzambalaorg/ui-kit";

export interface ICraftContactPanelProps {
  contract: IContract;
}

export const CraftContactPanel = (props: ICraftContactPanelProps) => {
  const { contract } = props;

  const { data = { count: 0 }, isLoading } = useFetchData<{ contractId: number }, { count: number }>(
    `/recipes/craft/count`,
    { contractId: contract.id },
    void 0,
    {
      embedded: true,
      method: "POST",
    },
  );
  const { count } = data;

  if (isLoading) {
    return null;
  }

  if (!count) {
    return null;
  }

  return (
    <Button<typeof RouterLink> type="button" component={RouterLink} to={`/recipes/craft?contractId=${contract.id}`}>
      <FormattedMessage id="form.buttons.craft" />
    </Button>
  );
};
